import { TProcessValues } from './processValues';

export const processHandicaps: TProcessValues = (values, start, end, partials) =>
  (values || [])
    .slice(start, end)
    .map(h => String(h))
    .reduce((acc: string[], hole: string, index: number) => {
      const partialNames = partials.filter(p => p.to === index + start).map(p => p.name);

      return partialNames ? [...acc, hole].concat(partialNames.map(_ => '')) : [...acc, hole];
    }, []);
